export const clientVersion = '1.0.8-210616_054236-e73a0fa';
